// extracted by mini-css-extract-plugin
module.exports = {"box":"friendlink-module--box--3SGxb"};